<template>
  <b-overlay :show="adsList === null" rounded="sm">
    <div v-if="adsList !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست آگهی ها</h1>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="adsList"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <!-- Column: inOnline -->

          <template #cell(reject)="data">
            <div class="cursor-pointer d-flex flex-row">
              <feather-icon
                v-b-modal.modal-reject
                @click="showModal(data.item)"
                icon="XIcon"
                size="20"
                class="text-danger"
              />
            </div>
          </template>
          <template #cell(confirm)="data">
            <div class="cursor-pointer d-flex flex-row">
              <feather-icon
                v-b-modal.modal-confirm
                @click="showModal(data.item)"
                icon="CheckIcon"
                size="20"
                class="text-success"
              />
            </div>
          </template>
          <template #cell(hasChat)="data">
            <div class="cursor-pointer d-flex flex-row">
              <feather-icon
                icon="CheckIcon"
                size="20"
                class="text-success"
                v-if="data.item.hasChat"
              />
              <feather-icon icon="XIcon" size="20" class="text-danger" v-else />
            </div>
          </template>
          <template #cell(description)="data">
            <div class="d-flex flex-row" style="max-width: 300px">
              {{ data.item.description }}
            </div>
          </template>
          <template #cell(status)="data">
            <div class="d-flex flex-row" style="max-width: 300px">
              {{ adStatuses[data.item.status] }}
            </div>
          </template>

          <!-- Column: delete -->

          <!-- <template #cell(delete)="data">
            <div
              class="cursor-pointer d-flex flex-row"
              v-b-modal.modal-delete
              @click="showModal(data.item.courseId)"
            >
              <feather-icon icon="TrashIcon" size="20" class="text-danger" />
            </div>
          </template> -->

          <template #cell(edit)="data">
            <router-link
              :to="{
                name: 'apps-ads-edit',
                params: { slug: data.item.catSlug, id: data.item.objectId },
              }"
              class="cursor-pointer d-flex flex-row"
            >
              <feather-icon icon="EyeIcon" size="20" />
            </router-link>
          </template>
          <template #cell(chat)="data">
            <router-link
              :to="{
                name: 'apps-chats',
                params: {
                  userId: data.item.userId,
                  mainFlatId: data.item.mainFlatTableId,
                },
              }"
              class="cursor-pointer d-flex flex-row"
            >
              <feather-icon icon="MessageSquareIcon" size="20" />
            </router-link>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalCount"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
      id="modal-reject"
      centered
      ok-title="رد آگهی"
      cancelTitle="انصراف"
      @ok="rejectAd(deleteItem)"
    >
      <span>آگهی رد شود؟</span>
    </b-modal>
    <b-modal
      id="modal-confirm"
      centered
      ok-title="تایید آگهی"
      cancelTitle="انصراف"
      @ok="confirmAd(deleteItem)"
    >
      <span>آگهی تایید شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { getUserData } from "@/auth/utils";
import axios from "axios";

export default {
  title: "لیست آگهی ها - پنل ادمین فرادیدار",
  name: "AdsList",
  data() {
    return {
      adsList: null,
      totalCount: null,
      addNewCategory: false,
      deleteItem: null,
      currentPage: 1,
      perPage: 10,
      searchCommand: "",
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        { key: "mainFlatTableId", label: "شناسه" },
        { key: "catName", label: "دسته بندی" },
        { key: "title", label: "عنوان" },
        { key: "description", label: "توضیحات" },
        { key: "hasChat", label: "قابلیت چت" },
        { key: "status", label: "وضعیت آگهی" },
        { key: "reject", label: "رد آگهی" },
        { key: "confirm", label: "تایید آگهی" },
        { key: "edit", label: "بازبینی" },
        { key: "chat", label: "چت ها" },
        // { key: "isOnline", label: "نوع استریم" },
        // { key: "delete", label: "حذف" },
        // { key: "edit", label: "ویرایش" },
      ],
      adStatuses: {
        1: "در انتظار تایید",
        2: "تایید شده",
        3: "رد شده",
      },
      defaultGetData: {
        status: null,
        pageNumber: 1,
        count: 10,
        searchCommand: null,
      },
      defaultCreateData: {
        isDeleted: false,
        productCategoryId: 0,
        parentId: 0,
        name: "",
      },
    };
  },
  async created() {
    axios.defaults.headers.common["Authorization"] = getUserData().data.token;
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    await this.getAllAds(
      this.defaultGetData.status,
      this.defaultGetData.pageNumber,
      this.defaultGetData.count,
      this.defaultGetData.searchCommand
    );
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
  watch: {
    currentPage: function (nv, ov) {
      this.getAllAds(
        this.defaultGetData.status,
        nv,
        this.defaultGetData.count,
        this.defaultGetData.searchCommand
      );
    },
  },
  methods: {
    async rejectAd(ad) {
      try {
        const response = await axios.post(
          "https://api.faradidar.com/api/MainFlatTable/ChangeAdsStatus",
          null,
          {
            params: {
              status: 3,
              objectId: ad.objectId,
              slug: ad.catSlug,
            },
          }
        );
        this.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `عملیات موفق`,
            icon: "CheckIcon",
            variant: "success",
            text: `آگهی رد شد.`,
          },
        });
      } catch (error) {
        if (error.response.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");

          // Remove userData from localStorage
          localStorage.removeItem("userData");

          // Reset ability
          this.context.$ability.update(initialAbility);

          // Redirect to login page
          this.context.$router.push({ name: "auth-login" });
        }
      }
      await this.getAllAds(
        this.defaultGetData.status,
        this.defaultGetData.pageNumber,
        this.defaultGetData.count,
        this.defaultGetData.searchCommand
      );
    },
    async confirmAd(ad) {
      try {
        const response = await axios.post(
          "https://api.faradidar.com/api/MainFlatTable/ChangeAdsStatus",
          null,
          {
            params: {
              status: 2,
              objectId: ad.objectId,
              slug: ad.catSlug,
            },
          }
        );
        this.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `عملیات موفق`,
            icon: "CheckIcon",
            variant: "success",
            text: `آگهی تایید شد.`,
          },
        });
      } catch (error) {
        console.error(error);
      }
      await this.getAllAds(
        this.defaultGetData.status,
        this.defaultGetData.pageNumber,
        this.defaultGetData.count,
        this.defaultGetData.searchCommand
      );
    },
    async getAllAds(status = null, pageNumber, count, searchCommand) {
      try {
        const response = await axios.post(
          "https://api.faradidar.com/api/MainFlatTable/GetAllForAdmin",
          null,
          {
            params: {
              status,
              pageNumber,
              count,
              searchCommand,
            },
          }
        );
        this.adsList = response.data.mainFlatTables;
        this.totalCount = response.data.count;
      } catch (error) {
        if (error.response.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");

          // Remove userData from localStorage
          localStorage.removeItem("userData");

          // Reset ability
          this.context.$ability.update(initialAbility);

          // Redirect to login page
          this.context.$router.push({ name: "auth-login" });
        }
      }
    },
    async deleteCourse(param) {
      let _this = this;

      let productCourseDeleteRequest = new ProductCourseDeleteRequest(_this);
      productCourseDeleteRequest.setId(param);
      await productCourseDeleteRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دوره حذف شد.`,
            },
          });
          _this.getAlladsList(
            _this.defaultGetData.pageNumber,
            _this.defaultGetData.count,
            _this.defaultGetData.searchCommand
          );
        },
        function (error) {
          console.log(error);
        }
      );
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param;
    },
  },
};
</script>

<style scoped></style>
